export interface SkillLevelItem {
  /** Display name, e.g. "Intermediate". */
  name: string
  /** 1-based ordering. */
  index: number
  /** Stored/submitted value — same as the name. */
  value: string
}

export const SKILL_LEVELS: SkillLevelItem[] = [
  { name: 'Beginner', index: 1, value: 'Beginner' },
  { name: 'Intermediate', index: 2, value: 'Intermediate' },
  { name: 'Advanced', index: 3, value: 'Advanced' },
  { name: 'Elite', index: 4, value: 'Elite' },
]
